<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" >
          <router-link v-if="!serverError" :to="{ name: `${routePrefix}.edit`,params:{id} }"  class="btn btn-primary btn-sm" v-can:edit="permissionPrefix">
            <i class="fa fa-edit"></i>
          </router-link>
        </card-header>
        <!-- Card body -->
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="!serverError">
              <select-app-device-types v-model="type" :options="{ id: 'app_device_type', label: 'type', action: action, disables: true }"/>
              <input-text v-model="name" :options="{ id: 'name', label: 'name', disabled: true }"/>
              <input-text v-model="bundle_id" :options="{ id: 'bundle_id', transPrefix: `${transPrefix}.fields`, label: 'bundle_id', disabled: true }"/>
              <input-text v-model="firebase_api_key" :options="{ id: 'firebase_api_key', transPrefix: `${transPrefix}.fields`, label: 'firebase_api_key', disabled: true }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { APPS_SHOW as CRUD_ACTION_SHOW,DEVICE_TYPE_LIST } from 'actions/platforms_portal/apps';
  const PLATFORMS_CRUD_CODE="platforms";
  const APPS_CRUD_CODE="apps";
  const PLATFORMS_APPS_CRUD_CODE=`${PLATFORMS_CRUD_CODE}.${APPS_CRUD_CODE}`;
  const CRUD_CODE=`platforms_portal.${APPS_CRUD_CODE}`;
  const CRUD_TRANS_CODE=`${PLATFORMS_APPS_CRUD_CODE}`;
  const CRUD_PERMISSION_CODE=`partner_apps`;
  export default {
    name: "PlatformsPortalAppShow",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_TRANS_CODE,
        permissionPrefix: `${CRUD_PERMISSION_CODE}`,
        platformsRoutePrefix: `${PLATFORMS_CRUD_CODE}`,
        platformsTransPrefix: `${PLATFORMS_CRUD_CODE}`,
        id:this.$router.currentRoute.params.id,
        action:DEVICE_TYPE_LIST,
        type: '',
        name: '',
        bundle_id: '',
        firebase_api_key: '',
        serverError: '',
        responseStatus:'',
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.id,
        }).then(response=>{
          this.type=response.data.type;
          this.name=response.data.name;
          this.bundle_id=response.data.bundleId;
          this.firebase_api_key=response.data.firebaseApiKey
        }).catch(error => {
          this.loading = false
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
    }
  };
</script>
